import './styles.css';
import { mountConfiguredMemberManagementReactApp } from './member/bootstrap';

const root = document.querySelector<HTMLDivElement>('#app');

if (!root) {
  throw new Error('Missing #app root element');
}

mountConfiguredMemberManagementReactApp(root);
